import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { fetchShopAndSubscriptions } from '../redux/actions/user';
import Loader from '../components/Layout/Loader';
import { isCanonicalSuperAdmin } from '../utils/privateLaunchAccess';

const ShopProtectedRoute = ({ children, requiredTiers }) => {
    const dispatch = useDispatch();
    const { isAuthenticated, user } = useSelector(state => state.user);
    const { isLoading, error, seller, isSeller } = useSelector(state => state.seller);
    const subscriptions = useSelector(state => state.seller.subscriptions);
    const [initialLoading, setInitialLoading] = useState(true);
    const bypassesSubscription = isCanonicalSuperAdmin(user);

    useEffect(() => {
        if (!seller || (!bypassesSubscription && !subscriptions)) {
            dispatch(fetchShopAndSubscriptions());
        } else {
            setInitialLoading(false);
        }
    }, [dispatch, seller, subscriptions, bypassesSubscription]);

    if (isLoading || initialLoading) {
        return <Loader />;
    }

    if (error) {
        console.error('Error fetching shop details:', error);
        return <div>Error: {error}</div>;
    }

    if (!isSeller) {
        console.log('No shop data available');
        return <div>No Shop Data</div>;
    }

    const hasRequiredTier = bypassesSubscription || subscriptions?.some(sub => requiredTiers.includes(sub.tier) && sub.status === 'active');

    if (!isAuthenticated || !isSeller || !hasRequiredTier) {
        console.log('Redirecting due to unmet conditions', { isAuthenticated, isSeller, hasRequiredTier, bypassesSubscription, subscriptions });
        return <Navigate to="/shop-subscriptions" replace />;
    }

    return children;
};

export default ShopProtectedRoute;


